import { render, staticRenderFns } from "./AdBannerDetail.vue?vue&type=template&id=427ee470&scoped=true&"
import script from "./AdBannerDetail.vue?vue&type=script&lang=js&"
export * from "./AdBannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdBannerDetail.vue?vue&type=style&index=0&id=427ee470&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ee470",
  null
  
)

export default component.exports